import React, { useState, useEffect } from "react";
import { Accordion, Alert, Button, Col, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useSubheader } from "../../../../_metronic/layout";
import axios from "axios";
import { HospitalData } from "../../subPages/HospitalData/HospitalData";
import { InssuredData } from "../../subPages/InsuredData/InssuredData";
import { Documentation } from "../../subPages/Documentation/Documentation";
import { Binnacle } from "../../subPages/Binnacle/Binnacle";
import AuthLetters from "../../subPages/AuthLetter/AuthLetters";
import { InssuredFile } from "../../subPages/InsuredFile/InssuredFile";
import { MedicalDataAdditional } from "../../subPages/AdditionalMedicalData/MedicalDataAdditional";
import {
  getBySlug,
  update,
} from "../../services/hospitalizationcrud";
import { isEmpty } from "../../../_utils/checkObjectEmpty";
import { getLetterMovsByCase } from "../../services/letterMovsService";
import moment from "moment";
import { MedicalFees } from "../../subPages/MedicalFee/MedicalFees";
import { getAllMedicalFees } from "../../services/medicalFeesService";
import { ProvidersData } from "../../subPages/SurgeryProvidersData/ProvidersData";
import { RegistrationCaseType } from '../../../helpers/constants';
import CaseHeader from "../../subPages/CaseHeader/CaseHeader";
import BlockCaseContext from "../../../contexts/BlockCaseContext";
import $ from 'jquery';

const MedicalInformationDetails = (props) => {
  const suhbeader = useSubheader();
  suhbeader.setTitle("INFORMACIÓN MÉDICA");

  const { slug } = props.match.params;

  const [caseRecord, setCaseRecord] = useState({});
  const [lettersMov, setLettersMov] = useState([]);
  const [totalLetters, setTotalLetters] = useState(0);
  const [shouldBlockCase, setShouldBlockCase] = useState(true);

  useEffect(() => {
    window.wasCommented = false;
    getBySlug(slug).then((response) => {
      setCaseRecord(response.data);
      window.requires_tabulation = response.data.requiresTabulation;
      getLetterMovsByCase(response.data.id).then((currrentLettersMov) => setLettersMov(currrentLettersMov.data));
    });
  }, [slug]);

  let history = useHistory();
  let submitFormInssuredFile = null;
  let submitFormInssuredFileErrors = null;
  let submitFormMedicalFee = null;
  let submitFormMedicalFeeErrors = null;
  let submitFormInssuredData = null;

  const bindSubmitFormInssuredFile = (submitForm) =>
    (submitFormInssuredFile = submitForm);

  const bindSubmitFormInssuredFileErrors = (errors) =>
    (submitFormInssuredFileErrors = errors);

  const bindSubmitFormMedicalFee = (submitForm) =>
      (submitFormMedicalFee = submitForm);

  const bindSubmitFormMedicalFeeErrors = (errors) =>
      (submitFormMedicalFeeErrors = errors);

  const bindSubmitFormInssuredData = (submitForm) =>
      (submitFormInssuredData = submitForm);

  const onClickSendControlDesk = async () => {
    const medicalFeesResponse = await getAllMedicalFees(caseRecord.id);

    await submitFormInssuredFile();
    await submitFormInssuredData();

    if (document.getElementById('si1').checked && medicalFeesResponse.data.length === 0) {
      await submitFormMedicalFee();
    }

    if (!validateRequireTabulation()) {
      alert("El campo requiere tabulacion es obligatorio");
      return;
    }

    if (isEmpty(submitFormInssuredFileErrors) && isEmpty(submitFormMedicalFeeErrors)) {
      if (!window.wasCommented) {
        alert("Debe ingresar un comentario");
        return;
      }

      const currentCaseType = document.getElementById('caseTypeOther')?.value;

      let timestamp = await axios.get('/cases/getTimestamp');
      const request_dic = {
        caseStatusId: 2,
        caseType: currentCaseType || caseRecord.caseType,
        feamesaControl: moment.utc(timestamp.data).format(),
        requiresTabulation: window.requires_tabulation ? window.requires_tabulation : null,
        requiresProviders: window.requires_providers ? window.requires_providers : null,
      };

      if (RegistrationCaseType.includes(document.getElementById('caseTypeOther').value) && !caseRecord.hospitalDateHire) {
        request_dic.hospitalDateHire = moment.utc(timestamp.data).format(); // Date.now();
      }

      $("#btn_save_comment").click();

      update(request_dic, caseRecord.id).then((response) => {
        history.push("/informacion_medica");
      });
    }
  }

  const onClickSave = async () => {
    const medicalFeesResponse = await getAllMedicalFees(caseRecord.id);

    await submitFormInssuredFile();
    await submitFormInssuredData();

    if (document.getElementById('si1').checked && medicalFeesResponse.data.length === 0) {
      await submitFormMedicalFee();
    }

    if (!validateRequireTabulation()) {
      alert("El campo requiere tabulacion es obligatorio");
      return;
    }

    if (isEmpty(submitFormInssuredFileErrors) && isEmpty(submitFormMedicalFeeErrors)) {
      const currentCaseType = document.getElementById('caseTypeOther')?.value;
      update({
        caseType: currentCaseType || caseRecord.caseType,
        requiresTabulation: window.requires_tabulation ? window.requires_tabulation : null,
        requiresProviders: window.requires_providers ? window.requires_providers : null }, caseRecord.id);
      $("#btn_save_comment").click();
      history.push("/informacion_medica");
    }
  }

  const validateRequireTabulation = () => {
    if(document.getElementById('si1').checked || document.getElementById('no1').checked) {
      return true;
    }

    return false;
  }

  return (
    <>
      <Alert
        variant="success"
        className="text-center"
        style={{ fontSize: "16px" }}
      >
        Informacion Medica
      </Alert>

      <CaseHeader
        caseRecord={caseRecord}
        requiresTabulationSlot={
          <>
            <b>Tabulacion: </b>
            {caseRecord.requiresTabulation}
          </>
        }
      />

      <BlockCaseContext.Provider value={[shouldBlockCase, setShouldBlockCase]}>
        <Accordion defaultActiveKey="6" className="mt-5">
          <MedicalDataAdditional
            icon ="fa-search"
            eventKey="6"
            data={caseRecord}
            bindSubmitForm={() => {}}
            disabled={true}
          />
        </Accordion>
        <Accordion defaultActiveKey="0" className="mt-5">
          <Documentation
            icon= "fa-pencil-alt"
            eventKey="4"
            data={caseRecord}
            disabledAll={false}
            typesDocument={[
              "Aviso de Accidente", "Carta de Autorización", "Comprobante de Seguro o Póliza", "Denuncia ante MP",
              "Estado de Cuenta Parcial", "Estado de Cuenta Final", "Estudios de Gabinete", "Estudios de Laboratorio",
              "Estudios que Confirmen DX", "Historia Clínica", "Identificación", "Informe Medico Actualizad",
              "Nota de Evolución", "Nota Postquirúrgica", "Resumen Medico Actualizado", "Otro",
            ]}
            {...props}
          />
          <MedicalFees
            icon= "fa-pencil-alt"
            eventKey="5"
            data={caseRecord}
            bindSubmitForm={bindSubmitFormMedicalFee}
            bindErrors={bindSubmitFormMedicalFeeErrors}
            {...props}
          />
          <AuthLetters
            icon="fa-search"
            showForm={false}
            hideDeleteOption={true}
            eventKey="3"
            data={caseRecord}
            disabledAll={false}
            setTotalLetters={setTotalLetters}
            {...props}
          />
          <InssuredData
            icon="fa-pencil-alt"
            eventKey="1"
            data={caseRecord}
            disabledAll={false}
            bindSubmitForm={bindSubmitFormInssuredData}
          />
          <HospitalData
            icon="fa-search"
            eventKey="2"
            data={caseRecord}
            disabledAll={true}
            bindSubmitForm={() => {}}
          />
          <ProvidersData
            icon= "fa-pencil-alt"
            eventKey="6"
            data={caseRecord}
            disabled={caseRecord?.hospital?.captProviders !== 1}
            {...props}
          />
          <InssuredFile
            icon="fa-pencil-alt"
            eventKey="0"
            data={caseRecord}
            lettersMov={lettersMov}
            totalLetters={totalLetters}
            bindSubmitForm={bindSubmitFormInssuredFile}
            bindErrors={bindSubmitFormInssuredFileErrors}
          />
        </Accordion>
        <Accordion defaultActiveKey="5" className="mt-5">
          <Binnacle
            icon="fa-pencil-alt"
            eventKey="5"
            data={caseRecord}
            disabledAll={false}
            eventStage="Informacion Medica"
            {...props}
          />
        </Accordion>
      </BlockCaseContext.Provider>

      <Row>
        <Col>
          <Button
            className="mt-5"
            variant="success"
            onClick={onClickSendControlDesk}
          >
            Enviar a Mesa de Control
          </Button>
        </Col>
        <Col className="mt-5 mr-5" onClick={onClickSave}>
          <Button variant="warning">Guardar Avance</Button>
        </Col>
      </Row>
    </>
  );
};

export default MedicalInformationDetails;
